
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_16a1p_13",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_16a1p_19",
  "size-x-small": "awsui_size-x-small_h11ix_16a1p_57",
  "size-x-small-mapped-height": "awsui_size-x-small-mapped-height_h11ix_16a1p_60",
  "size-small": "awsui_size-small_h11ix_16a1p_77",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_16a1p_80",
  "size-normal": "awsui_size-normal_h11ix_16a1p_97",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_16a1p_100",
  "size-medium": "awsui_size-medium_h11ix_16a1p_117",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_16a1p_120",
  "size-big": "awsui_size-big_h11ix_16a1p_137",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_16a1p_140",
  "size-large": "awsui_size-large_h11ix_16a1p_157",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_16a1p_160",
  "variant-normal": "awsui_variant-normal_h11ix_16a1p_177",
  "variant-disabled": "awsui_variant-disabled_h11ix_16a1p_180",
  "variant-inverted": "awsui_variant-inverted_h11ix_16a1p_183",
  "variant-subtle": "awsui_variant-subtle_h11ix_16a1p_186",
  "variant-warning": "awsui_variant-warning_h11ix_16a1p_189",
  "variant-error": "awsui_variant-error_h11ix_16a1p_192",
  "variant-success": "awsui_variant-success_h11ix_16a1p_195",
  "variant-link": "awsui_variant-link_h11ix_16a1p_198",
  "variant-info": "awsui_variant-info_h11ix_16a1p_201",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_16a1p_204",
  "name-angle-left": "awsui_name-angle-left_h11ix_16a1p_204",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_16a1p_206",
  "name-angle-right": "awsui_name-angle-right_h11ix_16a1p_206",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_16a1p_208",
  "name-arrow-right": "awsui_name-arrow-right_h11ix_16a1p_209",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_16a1p_210",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_16a1p_211",
  "name-audio-full": "awsui_name-audio-full_h11ix_16a1p_212",
  "name-audio-half": "awsui_name-audio-half_h11ix_16a1p_213",
  "name-audio-off": "awsui_name-audio-off_h11ix_16a1p_214",
  "name-external": "awsui_name-external_h11ix_16a1p_215",
  "name-redo": "awsui_name-redo_h11ix_16a1p_216",
  "name-resize-area": "awsui_name-resize-area_h11ix_16a1p_217",
  "name-send": "awsui_name-send_h11ix_16a1p_218",
  "name-shrink": "awsui_name-shrink_h11ix_16a1p_219",
  "name-undo": "awsui_name-undo_h11ix_16a1p_220",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_16a1p_221",
  "name-gen-ai": "awsui_name-gen-ai_h11ix_16a1p_599",
  "name-search-gen-ai": "awsui_name-search-gen-ai_h11ix_16a1p_599",
  "name-edit-gen-ai": "awsui_name-edit-gen-ai_h11ix_16a1p_599",
  "name-suggestions-gen-ai": "awsui_name-suggestions-gen-ai_h11ix_16a1p_599",
  "name-copy": "awsui_name-copy_h11ix_16a1p_599",
  "name-upload": "awsui_name-upload_h11ix_16a1p_599",
  "name-download": "awsui_name-download_h11ix_16a1p_599",
  "name-upload-download": "awsui_name-upload-download_h11ix_16a1p_599",
  "name-sign-out": "awsui_name-sign-out_h11ix_16a1p_599",
  "name-expand": "awsui_name-expand_h11ix_16a1p_599",
  "name-full-screen": "awsui_name-full-screen_h11ix_16a1p_599",
  "name-exit-full-screen": "awsui_name-exit-full-screen_h11ix_16a1p_599",
  "name-remove": "awsui_name-remove_h11ix_16a1p_599",
  "name-zoom-to-fit": "awsui_name-zoom-to-fit_h11ix_16a1p_599",
  "name-multiscreen": "awsui_name-multiscreen_h11ix_16a1p_599",
  "name-lock-private": "awsui_name-lock-private_h11ix_16a1p_599",
  "name-unlocked": "awsui_name-unlocked_h11ix_16a1p_599",
  "name-notification": "awsui_name-notification_h11ix_16a1p_599",
  "name-history": "awsui_name-history_h11ix_16a1p_599",
  "name-backward-10-seconds": "awsui_name-backward-10-seconds_h11ix_16a1p_599",
  "name-forward-10-seconds": "awsui_name-forward-10-seconds_h11ix_16a1p_599",
  "name-view-horizontal": "awsui_name-view-horizontal_h11ix_16a1p_599",
  "name-zoom-in": "awsui_name-zoom-in_h11ix_16a1p_599",
  "name-zoom-out": "awsui_name-zoom-out_h11ix_16a1p_599",
  "name-menu": "awsui_name-menu_h11ix_16a1p_599",
  "name-anchor-link": "awsui_name-anchor-link_h11ix_16a1p_599",
  "name-convert-code": "awsui_name-convert-code_h11ix_16a1p_599",
  "name-mini-player": "awsui_name-mini-player_h11ix_16a1p_599",
  "name-treeview-expand": "awsui_name-treeview-expand_h11ix_16a1p_599",
  "name-treeview-collapse": "awsui_name-treeview-collapse_h11ix_16a1p_599",
  "name-view-full": "awsui_name-view-full_h11ix_16a1p_599",
  "name-side-bar": "awsui_name-side-bar_h11ix_16a1p_599",
  "name-bug": "awsui_name-bug_h11ix_16a1p_599",
  "name-arrow-up": "awsui_name-arrow-up_h11ix_16a1p_599",
  "name-arrow-down": "awsui_name-arrow-down_h11ix_16a1p_599",
  "name-internal-link": "awsui_name-internal-link_h11ix_16a1p_599",
  "name-delete-marker": "awsui_name-delete-marker_h11ix_16a1p_599",
  "name-calendar": "awsui_name-calendar_h11ix_16a1p_599",
  "name-call": "awsui_name-call_h11ix_16a1p_599",
  "name-command-prompt": "awsui_name-command-prompt_h11ix_16a1p_599",
  "name-contact": "awsui_name-contact_h11ix_16a1p_599",
  "name-drag-indicator": "awsui_name-drag-indicator_h11ix_16a1p_599",
  "name-edit": "awsui_name-edit_h11ix_16a1p_599",
  "name-ellipsis": "awsui_name-ellipsis_h11ix_16a1p_599",
  "name-envelope": "awsui_name-envelope_h11ix_16a1p_599",
  "name-folder-open": "awsui_name-folder-open_h11ix_16a1p_599",
  "name-globe": "awsui_name-globe_h11ix_16a1p_599",
  "name-grid-view": "awsui_name-grid-view_h11ix_16a1p_599",
  "name-insert-row": "awsui_name-insert-row_h11ix_16a1p_599",
  "name-keyboard": "awsui_name-keyboard_h11ix_16a1p_599",
  "name-light-dark": "awsui_name-light-dark_h11ix_16a1p_599",
  "name-list-view": "awsui_name-list-view_h11ix_16a1p_599",
  "name-location-pin": "awsui_name-location-pin_h11ix_16a1p_599",
  "name-transcript": "awsui_name-transcript_h11ix_16a1p_599",
  "name-announcement": "awsui_name-announcement_h11ix_16a1p_605",
  "name-heart": "awsui_name-heart_h11ix_16a1p_616",
  "icon-pulse-soft": "awsui_icon-pulse-soft_h11ix_16a1p_1",
  "name-heart-filled": "awsui_name-heart-filled_h11ix_16a1p_624",
  "icon-pulse-strong": "awsui_icon-pulse-strong_h11ix_16a1p_1",
  "name-settings": "awsui_name-settings_h11ix_16a1p_632",
  "name-thumbs-up": "awsui_name-thumbs-up_h11ix_16a1p_643",
  "name-thumbs-up-filled": "awsui_name-thumbs-up-filled_h11ix_16a1p_654",
  "name-thumbs-down": "awsui_name-thumbs-down_h11ix_16a1p_665",
  "name-thumbs-down-filled": "awsui_name-thumbs-down-filled_h11ix_16a1p_676",
  "name-face-happy-filled": "awsui_name-face-happy-filled_h11ix_16a1p_687",
  "name-face-happy": "awsui_name-face-happy_h11ix_16a1p_687",
  "icon-mouth-smile-grow": "awsui_icon-mouth-smile-grow_h11ix_16a1p_1",
  "name-face-neutral": "awsui_name-face-neutral_h11ix_16a1p_721",
  "icon-mouth-tilt": "awsui_icon-mouth-tilt_h11ix_16a1p_1",
  "name-face-neutral-filled": "awsui_name-face-neutral-filled_h11ix_16a1p_743",
  "name-face-sad": "awsui_name-face-sad_h11ix_16a1p_754",
  "icon-mouth-frown-deepen": "awsui_icon-mouth-frown-deepen_h11ix_16a1p_1",
  "name-face-sad-filled": "awsui_name-face-sad-filled_h11ix_16a1p_777",
  "icon-sparkle-pinch": "awsui_icon-sparkle-pinch_h11ix_16a1p_1",
  "icon-nudge-up": "awsui_icon-nudge-up_h11ix_16a1p_1",
  "icon-nudge-down": "awsui_icon-nudge-down_h11ix_16a1p_1",
  "icon-nudge-up-once": "awsui_icon-nudge-up-once_h11ix_16a1p_1",
  "icon-nudge-down-once": "awsui_icon-nudge-down-once_h11ix_16a1p_1",
  "icon-nudge-back": "awsui_icon-nudge-back_h11ix_16a1p_1",
  "icon-shaft-retract": "awsui_icon-shaft-retract_h11ix_16a1p_1",
  "icon-nudge-forward": "awsui_icon-nudge-forward_h11ix_16a1p_1",
  "icon-nudge-up-right": "awsui_icon-nudge-up-right_h11ix_16a1p_1",
  "icon-nudge-in": "awsui_icon-nudge-in_h11ix_16a1p_1",
  "icon-nudge-down-left": "awsui_icon-nudge-down-left_h11ix_16a1p_1",
  "icon-bell-rotate": "awsui_icon-bell-rotate_h11ix_16a1p_1",
  "icon-ringer-bounce": "awsui_icon-ringer-bounce_h11ix_16a1p_1",
  "icon-panel-slide-down": "awsui_icon-panel-slide-down_h11ix_16a1p_1",
  "icon-panel-slide-right": "awsui_icon-panel-slide-right_h11ix_16a1p_1",
  "icon-dot-blink": "awsui_icon-dot-blink_h11ix_16a1p_1",
  "icon-nudge-right": "awsui_icon-nudge-right_h11ix_16a1p_1",
  "icon-bar-slide-left": "awsui_icon-bar-slide-left_h11ix_16a1p_1",
  "icon-gait-a": "awsui_icon-gait-a_h11ix_16a1p_1",
  "icon-gait-b": "awsui_icon-gait-b_h11ix_16a1p_1",
  "icon-glyph-nudge-up": "awsui_icon-glyph-nudge-up_h11ix_16a1p_1",
  "icon-glyph-nudge-down": "awsui_icon-glyph-nudge-down_h11ix_16a1p_1",
  "icon-glyph-nudge-left": "awsui_icon-glyph-nudge-left_h11ix_16a1p_1",
  "icon-glyph-nudge-right": "awsui_icon-glyph-nudge-right_h11ix_16a1p_1",
  "icon-handset-ring": "awsui_icon-handset-ring_h11ix_16a1p_1",
  "icon-cursor-blink": "awsui_icon-cursor-blink_h11ix_16a1p_1",
  "icon-meridian-turn": "awsui_icon-meridian-turn_h11ix_16a1p_1",
  "icon-key-press": "awsui_icon-key-press_h11ix_16a1p_1",
  "badge": "awsui_badge_h11ix_16a1p_2311",
  "custom-icon": "awsui_custom-icon_h11ix_16a1p_2325"
};
  